import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Title as TitleSC } from '@keytrade/components-title';
import { Paragraph as ParagraphSC } from '@keytrade/components-paragraph';

import { mediaQuery } from '@/utils/helpers';
const { getFont } = config.fonts;

const { list: colors } = config.colors;

export const Section = styled.section`
  padding: 4.8rem 1.6rem;
  background-color: white;
  ${({ color }) =>
    color.includes('gradient')
      ? `background-image: ${color};`
      : `background-color: ${color};`}
`;

export const SectionWrapper = styled.div<{ isWide: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: ${({ isWide }) => (isWide ? '112.8rem' : '84rem')};
  margin: 0 auto;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 5.6rem;

  ${mediaQuery.md(`
    flex-direction: row;
  `)}
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 74.4rem;
  margin: auto;
`;

export const Title = styled(TitleSC)`
  color: ${(props) => colors[props.color]} !important;
  text-align: center;
`;

export const Description = styled(ParagraphSC)`
  font-size: 1.8rem;
  color: ${(props) => colors[props.color]};
  text-align: center;
`;

// TODO: Share styles with JobListing
export const FilterContainer = styled.div`
  display: none;
  width: 100%;
  max-width: 264px;
  margin-right: 24px;
  ${mediaQuery.md(`
    display: block;
  `)}
`;

// TODO: Share styles with JobListing
export const FilterBlock = styled.div<{ isDark: boolean }>`
  ${mediaQuery.md(`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 12px;
    border: 1px solid #1E2A33;
    padding: 17px 24px;
    margin-bottom: 20px;
    `)}
  background-color: ${(props) => (props.isDark ? '#24323C' : colors.BlueLight)};
`;

export const FilterPills = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 80%;
`;

export const ClearFilters = styled.span`
  display: none;
  font-size: 14px;
  line-height: 20px;
  font-family: ${({ theme }) => getFont(theme, 'regular')};
  color: ${colors.BlueDawn};
  text-decoration: none;
  cursor: pointer;
  ${mediaQuery.md(`
    display: block;
  `)};
`;

export const TotalAmount = styled.span<{ isDark: boolean }>`
  display: none;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  font-family: ${({ theme }) => getFont(theme, 'regular')};
  color: ${(props) => (props.isDark ? colors.White : colors.BlueMoon)};
  ${mediaQuery.md(`
    display: block;
  `)};
`;
